<template>
    <templatePublicComponent>
        <div>
            <h3>Contact:</h3>
            <div class="content">
                <span style="font-size: 12pt; font-weight: bold;">
                    Déneigement Bourdeau Létourneau inc.
                </span>
                <br />
                <div class="message_contactus_contact">
                    Yannic Létourneau<br />
                    565 St-Régis Sud<br />
                    St-Constant QC<br />
                    J5A 2E7<br />
                    <br />
                    Tél: (450) 635-4622<br />
                    <a href="mailto:info@deneigementstecatherine.com">info@deneigementstecatherine.com</a>
                </div>
                <div style="margin-top:50px">
                    Notre partenaire<br />
                    <br />
                    <span style="font-size: 12pt; font-weight: bold;">
                        Déneigement RM Viau
                    </span>
                    <br />
                    321 St-Régis Sud<br />
                    St-Isidore-de-Laprairie Qué.ca J0L 2A0<br />
                    <br />
                    <a href="https://www.deneigement-rmviau.com">www.deneigement-rmviau.com</a><br />
                    <a href="mailto:info@deneigement-rmviau.com">info@deneigement-rmviau.com</a><br />
                    <br />
                    Jean Philippe (450) 454-6115<br />
                    Maxime Viau (450) 454-5411<br />
                    Gabriel Viau Gabriel@deneigement-rmviau.com<br />
                </div>
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '@/components/Frame.vue'
import TemplatePublicComponent from '@/components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ContactezNous.vue